
require('../../sass/xhpopulrz/download-app.scss');
require('../../sass/base/base.scss');
import Vue from 'vue'
import VueResource from 'vue-resource'
import MobileDetect from 'mobile-detect';
import xha from '@xhtech/xhanalysis-sdk';
// import { MD5 } from 'crypto-js'
import downloadApp from '../common/download-app';
import { isWeiXin, splitHost, storage, isAddGw, getDecryptPhone } from '../common/util';
import { getUrlParam } from '../utils/router'

import initMixin from '../../js/common/initMixin';

let md = new MobileDetect(window.navigator.userAgent);
Vue.use(VueResource)
new Vue({
  el: '#app',
  data() {
    return {
      isShow: false,
      isShowMask: false,
      weChatOS: null,
      clientPlatform: md.os() === 'iOS' ? 'iOS' : 'AndroidOS',
      errorState: {
        show: false,
        tip: null
      },
      mode: '',
      bgUrl: require('../../img/xhpopulrz/download/main.png'),
      btnUrl: require('../../img/xhpopulrz/download/btn.png'),
      btnAlt: '立即提现',
      showBtnAndFooter: true,
      pageDetail: '',
      noSuffix: '',
      appChannel: getUrlParam('appChannel') || getUrlParam('channelCode') || '',
      marketingId: getUrlParam('marketingId') || getUrlParam('phone') || '', // 加密后的手机号
      isRsa: getUrlParam('isRsa') || '', //是否是rsa加密
      requestId: getUrlParam('cid') || ''
    }
  },
  created() {

    const host = splitHost(location.host);

    // 埋点 sdk 初始化
    console.log('env', env.env);
    // console.log('prod',rocess.env.NODE_ENV);
    xha.init({
      appId: 'h5-mobile',
      api: env.env === 'production'
        ? '//sp.' + host + '/sp'
        : '//sptest.xiaohuaai.com/sp',
      // api:'//sptest.xiaohuaai.com/sp',
      env: env.env
    })
    xha.sdRegisterPage({
      appId: 'h5-mobile',
      clientVersion: '1.1'
    })

    /** customerid */
    let customerId = storage.get('customerId');
    if (!customerId) {
      let newUrl = isAddGw() ? '/gw/auth/user_info/h5' : '/auth/user_info/h5'
      this.$http.get(newUrl, {})
        .then(res => res.json())
        .then(resp => {
          if (resp.um) {
            xha.sdLogin(resp.um)
            storage.set('customerId', resp.um)
          }
        }).catch(error => {
        })
    } else {
      xha.sdLogin(customerId)
    }



    this.isShow = true
    xhTrack.log.onload('推广下载', '进入页面', Date.now());
    this.mode = getUrlParam('mode')
    this.pageDetail = getUrlParam('pageDetail')
    this.noSuffix = getUrlParam('noSuffix') || false


    this.downloadApp(true)
    this.isWeChat()


    if (this.isRsa === 'true') {
      this.rsaDecryptPhone()
    } else {
      // md5兼容有问题，先去掉
      // let cid = this.requestId ? MD5(this.requestId)?.toString() : ''
      // xha.sdLogin(cid)
      const decryptPhone = this.marketingId?getDecryptPhone(this.marketingId):''
      // 埋点上报解密后的手机号
      xha.trackEvent('EnterPageV2', {
        $title: '投放链接',
        url: location.href,
        $url: location.href,
        description: location.search,
        appChannel:this.appChannel,
        cid: this.requestId,
        phone: decryptPhone || this.marketingId || ''
      })
    }

    if (this.mode === 'amount') {
      this.bgUrl = require('../../img/xhpopulrz/download/new-bg.png')
      this.btnUrl = require('../../img/xhpopulrz/download/new-btn.png')
      this.btnAlt = '立即提额'

      xha.trackEvent('EnterPageV2', {
        $title: '下载引导页（半api）',
        platform_type: 'H5',
        $url: location.href,
        channel_id: this.appChannel,
        event_version: 'V1.0.2',
        chain_namespace: 'xiazaiyindaoye（banapi）'
      })

    } else if (this.mode === 'start-page') {
      this.bgUrl = require('../../img/xhpopulrz/download/start-page-bg.png')
      this.btnUrl = require('../../img/xhpopulrz/download/start-page-btn.png')
      this.btnAlt = '提额申请'
      xha.trackEvent('EnterPageV2', {
        $title: '有借有还 提额不难',
      })
    } else if (this.mode === 'extract-cash') {
      this.bgUrl = require('../../img/xhpopulrz/download/extract-cash.png')
      this.btnUrl = require('../../img/xhpopulrz/download/extract-cash-btn.png')
      this.btnAlt = '立即提现'
      xha.trackEvent('EnterPageV2', {
        $title: '限时享快速审批权益',
      })
    } else if (this.mode === 'extract-amount') {
      this.bgUrl = require('../../img/xhpopulrz/download/extract-amount.png')
      this.btnUrl = require('../../img/xhpopulrz/download/extract-amount-btn.png')
      this.btnAlt = '确认提额'
      xha.trackEvent('EnterPageV2', {
        $title: 'VIP专属提额加油包',
      })
    } else if (this.mode === 'short-link') {
      this.bgUrl = `${GLOBAL_URL.ROOT_MGM_CDN}/resources/images/xhqb-ex/new-page-back.png`
      this.btnUrl = ''
      this.showBtnAndFooter = false
      this.btnAlt = ''
      const decryptPhone = getDecryptPhone(this.marketingId)
      xha.trackEvent('EnterPageV2', {
        $title: '投放链接',
        url: location.href,
        $url: location.href,
        description: location.search,
        appChannel: this.appChannel,
        cid: this.requestId,
        phone: decryptPhone || this.marketingId || ''
      })
    } else if (['mini-app', 'mini-no-suffix'].includes(this.mode)) {
      this.bgUrl = `${GLOBAL_URL.ROOT_MGM_CDN}/resources/images/xhqb-ex/new-page-back.png`
      this.btnUrl = ''
      this.btnAlt = ''
      this.showBtnAndFooter = false
      const decryptPhone = getDecryptPhone(this.marketingId)
      xha.trackEvent('EnterPageV2', {
        $title: '投放链接',
        url: location.href,
        $url: location.href,
        description: location.search,
        appChannel: this.appChannel,
        cid: this.requestId,
        phone: decryptPhone || this.marketingId || ''
      })
    } else{
      xha.trackEvent('EnterPageV2', {
        $title: '下载引导页（半api）',
        platform_type: 'H5',
        $url: location.href,
        channel_id: this.appChannel,
        event_version: 'V1.0.2',
        chain_namespace: 'xiazaiyindaoye（banapi）'
      })
    }
  },
  mixins: [downloadApp, initMixin],
  methods: {
    toDownload() {
      if (this.mode === 'start-page') {
        xha.trackEvent('ElementClickV2', {
          $title: '有借有还 提额不难',
          elementName: '提额申请'
        })
      } else if (this.mode === 'extract-cash') {
        xha.trackEvent('ElementClickV2', {
          $title: '限时享快速审批权益',
          elementName: '立即提现'
        })
      } else if (this.mode === 'extract-amount') {
        xha.trackEvent('ElementClickV2', {
          $title: 'VIP专属提额加油包',
          elementName: '确认提额'
        })
      } else {
        xha.trackEvent('ElementClickV2', {
          $title: '下载引导页（半api）',
          elementName: '下载引导页点击事件',
          platform_type: 'H5',
          $url: location.href,
          channel_id: this.appChannel,
          event_version: 'V1.0.2',
          chain_namespace: 'xiazaiyindaoye（banapi）'
        })
      }

      xhTrack.log.onload('推广下载', '点击下载', Date.now());
      if (isWeiXin() && this.clientPlatform === 'AndroidOS') {
        this.isShowMask = true;
        return
      }
      this.downloadApp(true)
    },
    isWeChat() {
      if (isWeiXin()) {
        if (this.clientPlatform === 'iOS') {
          this.weChatOS = require('../../img/xhpopulrz/download/bubble-ios.png')
        } else if (this.clientPlatform === 'AndroidOS') {
          this.weChatOS = require('../../img/xhpopulrz/download/bubble-android.png')
        }
        this.isShowMask = true;
      }
    },
    closeMask() {
      this.isShowMask = false;
    },

    //获取rsa解密后手机号
    rsaDecryptPhone() {
      let decryptPhone = ''
      this.$http.post('/h5api/marketapi/user/decryptionStr', {
        encryptionStr: this.marketingId,
        code: 'jxt'
      }).then(resp => resp.json())
        .then(resp => {
          if (resp.success) {
            decryptPhone = resp.decryptionStr
          } else {
            decryptPhone = ''
          }
          // 埋点上报解密后的手机号
          xha.trackEvent('EnterPageV2', {
            $title: '投放链接',
            url: location.href,
            $url: location.href,
            pageStatus: decryptPhone || this.marketingId || ''
          })
        }).catch(error => { })
    }
  }
})



// WEBPACK FOOTER //
// ./web/js/xhpopulrz/download-app.js